// extracted by mini-css-extract-plugin
module.exports = {"categoryButton":"styles_categoryButton__46LUF","title":"styles_title__VBlI4","image":"styles_image__vILsf"};